import { render, staticRenderFns } from "./CruBuyingCost.vue?vue&type=template&id=a971f12e&"
import script from "./CruBuyingCost.vue?vue&type=script&lang=js&"
export * from "./CruBuyingCost.vue?vue&type=script&lang=js&"
import style0 from "./CruBuyingCost.vue?vue&type=style&index=0&id=a971f12e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports